export const samConstants = {
    RESET_SAM_CONVERSATION: "RESET_SAM_CONVERSATION",
    INJECT_SAM_BUBBLE: "INJECT_SAM_BUBBLE",
    INJECT_STUDENT_SCAN: "INJECT_STUDENT_SCAN",
    ACK_SAM_PROACTIVE_BUBBLE: "ACK_SAM_PROACTIVE_BUBBLE",
    DROP_SAM_MESSAGE: "DROP_SAM_MESSAGE",
}

// Provenance d'une bulle injectee. Seule une bulle "proactive" (le bonjour
// d'ouverture) laisse la feuille sur son ecran d'accueil : tout le reste est
// un vrai tour de parole, et fait donc basculer sur le fil.
export const SAM_BUBBLE_ORIGIN = Object.freeze({
    proactive: "proactive",
})

// Sam D-2 — namespaced keys for the proactive bubbles. Each bubble can
// be acked at most once per activity session — the hard cap of 2 auto
// relances comes from the size of this enum (cf. doctrine Q-D2.A).
export const SAM_PROACTIVE_KEY = {
    teaserT5: "teaser_t5",
    idleT3min: "idle_t3min",
}

// Sam D-1 — work qualifier levels (mirrors back enum).
export const SAM_COMPLETION_LEVEL = {
    // Sam n'arrive pas à lire la photo (flou, cadrage, reflet). À ne jamais
    // confondre avec `barelyStarted`, qui dit à l'élève qu'il n'a pas
    // travaillé — un élève qui cadre mal a souvent bien travaillé.
    unreadable: "unreadable",
    barelyStarted: "barely_started",
    partial: "partial",
    advanced: "advanced",
}

// Forme vide partagée par le reducer et les hooks : une seule définition, et
// une identité stable — un `|| SAM_EMPTY_CONVERSATION` dans un useSelector
// rend toujours le même objet, sans re-render inutile.
export const SAM_EMPTY_CONVERSATION = Object.freeze({
    messages: [],
    isThinking: false,
    conversationUuid: null,
    capReached: false,
    degraded: false,
    lastMood: "encouraging",
})

export const SAM_TRIGGERS = {
    askHelp: "ask_help",
    hint: "hint",
    freeText: "free_text",
    feedbackReaction: "feedback_reaction",
    // Rappeler une règle du cours n'est pas demander de l'aide : sous
    // `ask_help`, la consigne du modèle est « reformule l'objectif et propose
    // une question d'amorce » — l'élève recevait une question, pas la règle
    // que la pastille lui promettait.
    courseReminder: "course_reminder",
}

// Le jour local de l'élève : le plafond de messages du jour ne vaut que pour
// aujourd'hui, et se lit d'une activité à l'autre.
export const samDayKey = (date = new Date()) =>
    `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

// (Le micro Whisper est le lot B : il revient avec sa route de transcription.
// Son ébauche est dans l'historique de cette branche, avant le passage
// /simplify du 10/10.)

// Global kill switch (B9) — paired with `SAM_ENABLED` on the back-end.
// `EXPO_PUBLIC_SAM_ENABLED` defaults to enabled; only `"false"` flips it off,
// so a missing env var keeps Sam visible in dev/preview builds.
export const SAM_ENABLED =
    String(process.env.EXPO_PUBLIC_SAM_ENABLED ?? "true").toLowerCase() !==
    "false"

// « Sam est-il ouvert pour cet élève ? » — la seule lecture de la règle côté
// app (l'interrupteur, puis `sam_eligible` posé par le serveur). Chaque appelant
// garde ses conditions à lui (live, mode parent, bannière).
export const isSamOpenFor = (user) => SAM_ENABLED && !!user?.sam_eligible
